export default {
  isAuthenticated: state => {
    return state.user.token !== null
  },

  getWindowWidth: state => {
    return state.windowWidth
  },

  playerResultId: state => {
    return state.user.playerResultId
  },

  isEvaluator: state => {
    if (state.user) {
      return state.user.details.authorities.includes('ROLE_EVALUATOR')
    }
  },

  isEvaluatorButCandidate: state => {
    if (state.user) {
      if (state.user.details.authorities.includes('ROLE_EVALUATOR')) {
        if (state.user.details.id == state.assessment.candidate.id) {
          return true
        }
      }
    }
    return false
  },

  isFirstEvaluator: state => {
    if (state.user && state.assessment) {
      if (state.assessment.firstEvaluator != null) {
        return state.user.details.id === state.assessment.firstEvaluator.id
      }
      return false
    }
  },

  isSecondEvaluator: state => {
    if (state.user && state.assessment) {
      if (state.assessment.secondEvaluator != null) {
        return state.user.details.id === state.assessment.secondEvaluator.id
      }
      return false
    }
  },

  gameplay: state => {
    return state.gameplay
  },

  assessment: state => {
    return state.assessment
  },

  assessmentId: state => {
    return state.assessmentId
  },

  answers: state => {
    return state.answers
  },

  barKey: state => {
    return state.barKey
  },

  isCompleted: (state, getters) => {
    if (state.assessment) {
      if (state.assessment.secondEvaluator != null) {
        return getters.isCompletedByCandidate && getters.isCompletedByFirstEvaluator && getters.isCompletedBySecondEvaluator
      }
      return getters.isCompletedByCandidate && getters.isCompletedByFirstEvaluator
    }
    return false
  },

  isCompletedByCandidate: state => {
    if (state.assessment) {
      return state.assessment.candidateScore != null
    }
    return false
  },

  isCompletedByFirstEvaluator: state => {
    if (state.assessment) {
      return state.assessment.firstEvalScore != null
    }
    return false
  },

  isCompletedBySecondEvaluator: state => {
    if (state.assessment) {
      return state.assessment.secondEvalScore != null
    }
    return false
  },

  sectors: state => {
    if (state.gameplay) {
      return state.gameplay.appraisalSectors
    }
    return null
  },

  activeSector: (state, getters) => {
    if (state.gameplay) {
      const sectors = state.gameplay.appraisalSectors
      let currentSectorId = state.assessment.currentCandidateSectionId
      if (getters.isFirstEvaluator) {
        currentSectorId = state.assessment.currentFirstEvalSectionId
      }
      else if (getters.isSecondEvaluator) {
        currentSectorId = state.assessment.currentSecondEvalSectionId
      }

      if (currentSectorId === null) {
        return sectors[0]
      }

      const currentSector = sectors.find(sector => sector.id === currentSectorId)

      return currentSector
    }
    return null
  },

  activeSectorIndex: (state, getters) => {
    if (state.gameplay) {
      const activeSector = getters.activeSector
      const sectors = state.gameplay.appraisalSectors

      return sectors.findIndex(sector => sector.id === activeSector.id)
    }
    return 0
  },

  user: state => {
    return state.user.details
  },

  candidate: state => {
    return state.assessment.candidate
  },

  gameplayProfile: state => {
    return state.gameplay ? state.gameplay.gameplayProfile : null
  }
}
